module.exports = __webpack_public_path__ + "img/increase.af4c3b5.svg";